// extracted by mini-css-extract-plugin
export default {"orderHeader":"CompanyCategories_orderHeader__QdGZr","button":"CompanyCategories_button__qOIgl","productsContainer":"CompanyCategories_productsContainer__9jrpD"};